import postgreApiService from "./apiService";
import { RPC_PROFILE_ENDPOINTS } from "../endpoints";
import { getStoredUsername } from "../../utils/user";
import { isSuccess } from "./utils";

const normalizeProfile = (raw) => {
    const d = raw?.Data || raw?.data || raw;
    return {
        id: d?.LoginUserId || d?.Id || d?.id || d?.UserId || d?.userId || d?.UserID || d?.user_id || 0,
        Email: d?.Email || d?.email || "",
        email: (d?.Email || d?.email || "").toLowerCase(),
        firstName: d?.FirstName || d?.firstName || d?.first_name || "",
        lastName: d?.LastName || d?.lastName || d?.last_name || "",
        phone: d?.Phone || d?.phone || "",
        street: d?.Street || d?.street || "",
        number: d?.Number || d?.number || "",
        city: d?.City || d?.city || "",
        postalCode: d?.PostalCode || d?.postalCode || d?.postal_code || "",
        area: d?.Area || d?.area || "",
        profilePhotoUrl: d?.ProfilePhotoUrl || d?.profilePhotoUrl || d?.profile_photo_url || "",
        maxGifts: d?.MaxGifts ?? d?.maxGifts ?? d?.max_gifts ?? null,
        maxOrders: d?.MaxOrders ?? d?.maxOrders ?? d?.max_orders ?? null,
        totalOrders: d?.TotalOrders ?? d?.totalOrders ?? d?.total_orders ?? 0,
        giftsCount: d?.GiftsCount ?? d?.giftsCount ?? d?.gifts_count ?? 0,
        orderFrequency: d?.OrderFrequency ?? d?.orderFrequency ?? d?.order_frequency ?? null,
        latestOrderCreatedOn: d?.LatestOrderCreatedOn ?? d?.latestOrderCreatedOn ?? d?.latest_order_created_on ?? null,
        maxNumberOfProductPerOrder: d?.MaxNumberOfProductPerOrder ?? d?.maxNumberOfProductPerOrder ?? d?.max_number_of_product_per_order ?? null,
        location: d?.Location || d?.location || "",
        countryId: d?.CountryId ?? d?.countryId ?? null,
        companyId: d?.CompanyID || d?.CompanyId || d?.companyId || d?.company_id || null,
        isFirstOrderPreApproved: d?.IsFirstOrderPreApproved ?? d?.isFirstOrderPreApproved ?? true,
        age: d?.AccountAgeId ?? d?.Age ?? d?.age ?? null,
        categories: (() => {
            const raw = d?.Category || d?.Categories || d?.categories || "";
            if (!raw) return [];
            if (Array.isArray(raw)) return raw.map(String);
            return String(raw).split(",").map((s) => s.trim()).filter(Boolean);
        })(),
        comment: d?.Comment || d?.comment || "",
        socialMediaAccounts: Array.isArray(d?.SocialMediaJson || d?.SocialMediaDetails)
            ? (d.SocialMediaJson || d.SocialMediaDetails).map((s) => ({
                name: s?.SocialMediaName || "",
                code: s?.SocialMediaCode || "",
                handle: s?.SocialMediaAccountName || "",
                profileUrl: s?.SocialMediaUrl || "",
                url: s?.SocialMediaUrl || "",
                icon: s?.SocialMediaImageUrl || "",
            }))
            : [],
    };
};


export const getProfile = async () => {
    const p_username = getStoredUsername();
    const response = await postgreApiService.post(RPC_PROFILE_ENDPOINTS.GET, { p_username });
    const data = response?.data || {};
    return normalizeProfile(data);
};

export const getProfileByEmail = async (email) => {
    const response = await postgreApiService.post(RPC_PROFILE_ENDPOINTS.GET, { p_username: email });
    const data = response?.data || {};
    return normalizeProfile(data);
};

export const updateProfile = async (payload) => {
    const p_username = getStoredUsername();
    const body = {
        p_username,
        p_first_name: payload.firstName || "",
        p_last_name: payload.lastName || "",
        p_email: payload.email || p_username,
        p_phone: payload.phone || "",
        p_street: payload.street || "",
        p_number: payload.number || "",
        p_city: payload.city || "",
        p_postal_code: payload.postalCode || "",
        p_area: payload.area || "",
        p_country_id: payload.countryId ? Number(payload.countryId) : null,
        p_account_age_id: payload.age ? Number(payload.age) : null,
        p_category: (() => {
            const cats = Array.isArray(payload.categories) ? payload.categories : [];
            if (cats.some((c) => c === "all" || c === 0)) return "All";
            const ids = cats.map(Number).filter(Boolean);
            return ids.length ? ids.join(",") : "";
        })(),
        p_comment: payload.comment || "",
        p_profile_photo_url: payload.profilePhotoUrl || null,
        p_social_media_json: Array.isArray(payload.socialMediaJson) ? payload.socialMediaJson : [],
    };
    const response = await postgreApiService.post(RPC_PROFILE_ENDPOINTS.UPDATE, body);
    const data = response?.data || {};
    return {
        success: isSuccess(data?.Success),
        message: data?.Message || "",
    };
};

